import { TApplicationState } from '../../types/redux';

export function getMapApiKey(state: TApplicationState) {
  return state.common.mapApiKey;
}
